import { lessonSelectors } from 'common/modules/ReactShared';
import { useMemo } from 'react';
import { useTypedSelector } from 'students/stores/_utils';
import { isLightFontNeeded } from 'students/views/shared/helpers';

/** Whether the footer's ink sits on a light lesson colour and must be dark. */
export function useNavFooterIsDarkFont(): boolean {
  const lesson = useTypedSelector(lessonSelectors.selectLesson);
  const background = lesson?.color;

  return useMemo(
    () => (background ? !isLightFontNeeded(background) : false),
    [background]
  );
}
